export default {
  methods: {
    $dt: function (translate) {
      if (typeof translate === "string") {
        return translate;
      } else if (translate === void 0) {
        throw Error("Translation missing.");
      }

      return (
        translate[this.$i18n.locale] || translate[this.$i18n.fallbackLocale]
      );
    },
  },
};
